<!--
 * @Author: your name
 * @Date: 2020-03-13 16:31:00
 * @LastEditTime: 2022-05-08 16:59:20
 * @LastEditors: yjf531 yjf531@126.com
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Apply.vue
 -->
<template>
  <div class="Baoming">
       <img class="sub-logo2" src="../assets/baomingLogo.png">
  <div class="content">
    <div class="body">
    <div class="top">
        <img src="../assets/baomingTop.png" class="topImg">
    </div>
     <div class="registered">
         <div v-show="isShow">
                <van-field
                  v-model="name"
                  label="姓名"
                  :left-icon="require('../assets/baoming1.png')"
                   style="opacity:0.8;border-bottom:0;background-color:#041d34;color:#fff;"
                  placeholder="请输入您的姓名"
              >
                <template v-slot:input>
               <input type="text" placeholder="请输入您的姓名" class="van-field__control" style="color: #fff;border-bottom: 1px solid #50d7e2;"  v-model="name">
            </template>
                 </van-field>
               <van-field
                  v-model="province"
                  label="省份"
                  :left-icon="require('../assets/baoming2.png')"
                  :right-icon="require('../assets/baoming-icon.png')"
                  placeholder="请输入您的省份"
                   style="opacity:0.8;border-bottom:0;background-color:#041d34;color:#fff;"
                  @click="() => {this.showPicker2 = true}"
              >
                <template v-slot:input>
               <input type="text" placeholder="请输入您的省份" class="van-field__control" style="color: #fff;border-bottom: 1px solid #50d7e2;"  v-model="province" readonly>
            </template>
                 </van-field>
                   <van-field
                  v-model="city"
                  label="城市"
                  :left-icon="require('../assets/baoming2.png')"
                  placeholder="请输入您的城市"
                   style="opacity:0.8;border-bottom:0;background-color:#041d34;color:#fff;"
              >
                <template v-slot:input>
               <input type="text" placeholder="请输入您的城市" class="van-field__control" style="color: #fff;border-bottom: 1px solid #50d7e2;"  v-model="city">
            </template>
                 </van-field>
                   <van-field
                  v-model="country"
                  label="区县"
                  :left-icon="require('../assets/baoming2.png')"
                  placeholder="请输入您的区县"
                   style="opacity:0.8;border-bottom:0;background-color:#041d34;color:#fff;"
              >
                <template v-slot:input>
               <input type="text" placeholder="请输入您的区县" class="van-field__control" style="color: #fff;border-bottom: 1px solid #50d7e2;"  v-model="country">
            </template>
                 </van-field>
               <van-field
                  v-model="unit_name"
                  label="单位"
                  :left-icon="require('../assets/baoming3.png')"
                  placeholder="请输入您的单位"
                   style="opacity:0.8;border-bottom:0;background-color:#041d34;color:#fff;"
              >
                <template v-slot:input>
               <input type="text" placeholder="请输入您的单位" class="van-field__control" style="color: #fff;border-bottom: 1px solid #50d7e2;"  v-model="unit_name">
            </template>
                 </van-field>
               <van-field
                  v-model="mechanism"
                  label="职务/职称"
                  :left-icon="require('../assets/baoming4.png')"
                   style="opacity:0.8;border-bottom:0;background-color:#041d34;color:#fff;"
                  placeholder="请输入您的职务/职称"
              >
              <template v-slot:label>
               <div class="van-cell__title van-field__label" style="width: 90px;"><span>职务/职称</span></div>
            </template>
                <template v-slot:input>
               <input type="text" placeholder="请输入您的职务/职称" class="van-field__control" style="color: #fff;border-bottom: 1px solid #50d7e2;margin-left: 24px;"  v-model="mechanism">
            </template>
                 </van-field>
                <van-field
                  v-model="tel"
                  label="电话"
                  :left-icon="require('../assets/baoming5.png')"
                   style="opacity:0.8;border-bottom:0;background-color:#041d34;color:#fff;"
                  placeholder="请输入您的电话"
              >
                <template v-slot:input>
               <input type="text" placeholder="请输入您的电话" class="van-field__control" style="color: #fff;border-bottom: 1px solid #50d7e2;"  v-model="tel">
            </template>
                 </van-field>

              <p class="tip">您提供的所有信息仅限该会议报名使用且受到严格保护</p>
              
              <van-row class="bottom" type="flex" justify="center">
                <van-col ><van-button type="info" class="confirm" @click="editUser()">确认提交</van-button></van-col>
              </van-row>
            </div>
            <div v-show="!isShow">
                 <van-field
                  v-model="yanZhengMa"
                  label="验证码"
                  :left-icon="require('../assets/baoming1.png')"
                  style="opacity:0.8;border-bottom:0;background-color:#041d34;color:#fff;"
                  placeholder="请输入您的验证码"
              >  
               <template v-slot:label>
               <div class="van-cell__title van-field__label" style="width: 50px;"><span>验证码</span></div>
            </template>
              <template v-slot:input>
                <input type="text" placeholder="请输入您的验证码" class="van-field__control" style="color: #fff;border-bottom: 1px solid #50d7e2; margin-left: 12px;"  v-model="yanZhengMa">
            </template>
                 </van-field>
              <van-row class="bottom" type="flex" justify="center">
                <van-col ><van-button type="info" class="confirm" @click="check()">提交</van-button></van-col>
              </van-row>
            </div>
     </div>
      <div :class="bottom">
            <img src="../assets/baomingBottom.png" class="bottomImg">
        </div>
    </div>
  </div>
    <van-popup v-model="showPicker2" position="bottom">
        <van-picker
          show-toolbar
          :columns="[
            '北京','天津','河北','山西','内蒙古','辽宁','吉林','黑龙江','上海','江苏','浙江','安徽','福建','江西','山东','河南','湖北','湖南','广东','广西','海南','重庆','四川','贵州','云南','西藏','陕西','甘肃','青海','宁夏','新疆','兵团','香港','澳门','台湾'
          ]"
          @cancel="showPicker2 = false"
          @confirm="onConfirm2"
        />
      </van-popup>
       <share></share>
  </div>
</template>

<script>
import { Http } from '@/utils/http.js'
import api   from '@/config/api.js'
import Cookies from 'js-cookie'
import axios from 'axios'


export default {
  name: 'Apply',
  data() {
    return {
      isSubmit: false,
      name: '',
      wx_name: '',
      wx_province: '',
      wx_city: '',
      wx_sex: '',
      mechanism: '',
      unit_name: '',
      tel: '',
      openid: '',
      province: '',
      city: '', // 城市
      country: '', // 区县
      meeting_id: 3, // 会议ID
      showPicker2: false,
      yanZhengMa: '', // 验证码
      isShow: true,// 会议密码输入对了则显示注册
      bottom: 'bottom3'

    };
  },

  methods: {
        // 省份下拉框
    onConfirm2 (value) {
      this.showPicker2 = false
      this.province = value
    },
        // 弹框
    customAlert(msg){
      this.$dialog.alert({
          message: msg
      });
      return
    },
    // 验证码判断
    check() {
        this.yanZhengMa = this.yanZhengMa.trim();
        if(!this.yanZhengMa){
            this.customAlert("验证码不能为空")
            return false
        }
        if (this.yanZhengMa != 'manbing06') {
            this.customAlert("验证码不对")
            return false
        }
        this.isShow = true
        this.bottom = 'bottom3'
        return 
    },
      // 修改用户信息
      editUser(){
        this.name = this.name.trim();
        this.tel = this.tel.trim();
        this.province = this.province.trim();
        this.mechanism = this.mechanism.trim();
        this.unit_name = this.unit_name.trim();
        if(!this.name || !this.tel || !this.province || !this.mechanism || !this.unit_name){
            this.customAlert("个人信息请填写完整")
            return false
        }
        // 判断手机号格式
        const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!myreg.test(this.tel)) {
            this.customAlert("请输入准确的手机号")
            return false
        }
        // if(this.isSubmit){
        //     this.customAlert('正在提交')
        //     return false
        // }
        this.isSubmit = true
        let data = {}
        data.openid = this.openid
        data.tel = this.tel
        data.name = this.name
        data.wx_name = this.wx_name
        data.wx_sex = this.wx_sex
        data.province = this.province
        data.wx_province = this.wx_province
        data.wx_city = this.wx_city
        data.mechanism = this.mechanism
        data.unit_name = this.unit_name
        data.meeting_id = this.meeting_id
        data.city = this.city
        data.country = this.country
        // return
        Http.post(api.addMeetingUser, data).then((response) => {
            this.isSubmit = false
            const v2 = Math.ceil(Math.random()*100)
            this.$router.push({ name: "BaomingSuccess", query: { v: v2 } })
            return false
            // if(response.code == 1){
            //     // 提交成功
            //     this.customAlert('提交成功')
            //     this.$router.push({ name: "BaomingSuccess"})
            //     return false
            // }else{
            //     // 发送失败
            //     this.customAlert('')
            //     return false
            // }
          })
        return false;

      },
      // 获取用户信息
      getUserInfo(){
        this.wx_name = Cookies.get('nickname')
        this.wx_province = Cookies.get('province')
        this.wx_city = Cookies.get('city')
        this.wx_sex = Cookies.get('sex')
        return 
        // 视频数据
        let data = {}
        data.openid = this.openid
        Http.post(api.getWechatUserInfo, data).then(response => {
            if (response.code == 1) {
                // 写入返回的cookie 值
                const data = response.data
                this.wx_name = data.nickname
                this.wx_province = data.province
                this.wx_city = data.city
                this.wx_sex = data.sex
            } 
            return 
        })
      },
      // 获取会议开关
    getSwitch() {
        let data = {}
        data.meetid = 1001
        data.type = 3
        Http.post(api.getQrcode, data).then((response) => {
            const a = response.data.thumb
            if(a == 2){
              this.$router.push({ name: "BaomingClose", query: { v: 33 } })
            }
        });
        return false;
    },
  },
  created: function(){
    this.getSwitch()
  },
  mounted: function() {
    this.openid = Cookies.get('openid')
    document.title = '报名系统'
    // 跳转到首页
    // if(!this.openid){
    //     this.$router.push({ name: "Baoming"})
    // }
    // 获取用户信息
    this.getUserInfo()
  }

};
</script>

<style lang="less">
.Baoming {
  font-size: 16px;
    display: flex;
    flex-direction: column;
     background-color: #041d34;
      min-height: 100vh;
     .sub-logo2 {
        position: absolute;
        width: 40px;
        top: 20px;
        left: 20px;    
    }
  .content {
    position: relative;
     min-height: 100vh;
    .top {
        margin: 52px auto 0;
        width: 90%;
        .topImg {
            width: 100%;
        }
    }
    .bottom2 {
        margin-top: 12px;
          position: fixed;
        bottom: 0px;
        .bottomImg {
            width: 100%;
        }
    }
     .bottom3 {
        margin-top: 12px;
        .bottomImg {
            width: 100%;
        }
    }
    .registered {
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0 20px;
        width: 90%;
        margin: auto;
        .title{
          margin-top: 20px;
          margin-bottom: 28px;
          font-size: 20px;
          text-align: center;
          height: 20px;
          line-height: 20px;
          color: #028fe1;
        }
        .van-cell {
          align-items: center;
          border-bottom: 1px solid #dcdcdc;
          font-size: 14px;
          margin-top: 10px;
        }
        .van-field__control {
           color: #fff;
        }
        ::-webkit-input-placeholder {
            color: #072d47;
        }
        .van-cell__value { 
            margin-left: 12px;
        }
        .van-cell { 
            margin-top: 0px;
        }
        .van-field__label {
            width: 30px;
            font-size: 14px;
            color: #22e2ff;
        }

        .van-cell:not(:last-child)::after {
            border-bottom: 0px;
        }
        .tip {
            font-size: 12px;
            color: #1aa6d3;
        }
        .bottom {
            margin-top: 30px;
            margin-bottom: 30px;
            .confirm {
              width: 120px;
              height: 40px;
              border-radius: 18px;
              font-size: 18px;
              background-color:#041f39;
                border: 1px solid #74a2ce;
                color: #2d6d9c;
            }
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Baoming.vue